import { gql } from "@apollo/client";

const Fragments = {
  userAdditionalData: gql`
    fragment userAdditionalData on UserAdditionalData {
      userId
      avatar
    }
  `
};

export default Fragments;
